import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

import { ResponseInterface } from 'src/app/core/interfaces/response-interface';
import { MomentService } from 'src/app/vehicles/services/moment.service';
import { Recorrido } from '../models/interface';


@Injectable({
  providedIn: 'root'
})
export class FollowLinkService {


  public map!: L.Map;
  tramasHistorial: any;
  eventsHistorial:any;
  // arrayRecorridos: any;
  public arrayRecorridos : Recorrido[] = [];
  // public keyGrafico : string = "";
  
  constructor(
        private http: HttpClient,
        private momentService: MomentService,

  ) { }

  // async getAll(id_seguimiento: string) {
  //   try {
  //     const resp = await this.http.get(`${environment.apiUrl}/api/seguimiento/${id_seguimiento}`).toPromise();
  //     console.log(resp);
  //   } catch (error) {
  //     console.error('Error al obtener datos:', error);
  //   }
  // }


  loadMap(map: any): void {
    // //console.log("loadMap");
    this.map = map;
  }
  
  getDataSeguimiento(params: any){
    console.log("============================= XX ");
    console.log(params);
    // let url = `${environment.apiUrl}/seguimiento/${id_seguimiento}`;
    let url = `${environment.apiUrl}/api/seguimiento`;

    console.log(url);
    // return this.http.get(url);
    return this.http.post(url,params);
  }


  getLastTrama(param:any) {
    let url = `${environment.apiUrl}/api/seguimiento/lastTrama`;
    return this.http.post(url,param);
  }

  // getDataIbuttons(id: string) {
  //   let url = `${environment.apiUrl}/api/getIbutton/${id}`;
  //   this.ibuttons = this.http.get(url);
  //   console.log("--------------lista de ibuttons");
  //   console.log(this.ibuttons);
  //   //return buttons;
  // }

  async getReference(lat: any, lng: any) {
    const response:ResponseInterface = await this.http
      .get<ResponseInterface>(`${environment.apiUrl}/api/seguimiento/get-reference-follow`, {
        params:
        {
          latitud:lat,
          longitud:lng
        }
      })
      .toPromise();

      // console.log("===============================");
      // console.log(response);

      return response.data;
  }


  async get_tramas_recorrido_varios_sin_permiso(param:any) {
    console.log(" ===> get_tramas_recorrido_varios_sin_permiso");
    console.log(param);
    
    param.tzCustom = this.momentService.tzCustom;
    param.tzOffset = this.momentService.tzOffset;
    param.tzPHP = this.momentService.tzPHP;

    console.log(param);

    this.tramasHistorial = await this.http.post(`${environment.apiUrl}/api/historial_varios_sin_permiso`,param).toPromise();

    return 'listoooo';
  }

  public async ShowAllHistorial(param:any) {
    console.log(" ===> ShowAllHistorial");
    console.log(param);
    
    param.tzCustom = this.momentService.tzCustom;
    param.tzOffset = this.momentService.tzOffset;
    param.tzPHP = this.momentService.tzPHP;

    param.fecha_desde = "2025-02-19 00:00:00-05";
    param.fecha_hasta = "2025-02-19 00:00:00-05";
    console.log(param);

    this.eventsHistorial = await this.http.post(`${environment.apiUrl}/api/historial_varios_sin_permiso`,param).toPromise();

  }





}
